import { ReactNode } from "react";
import { IconAtom, IconSize } from "../icon";
import { SpacerAtom } from "../spacer";
import styles from "./styles.module.scss";

interface Props {
  icon: string;
  iconSize?: IconSize;
  children: ReactNode;
}

export function IconTextCellAtom({ icon, iconSize = "large", children }: Readonly<Props>) {
  return (
    <div className={styles.center}>
      <IconAtom icon={icon} size={iconSize} aria-hidden="true" />
      <SpacerAtom space={1} />
      <div className={styles.text}>{children}</div>
    </div>
  );
}

export function TruncatedTextAtom(props: Readonly<{ children: ReactNode }>) {
  return <div className={styles.text}>{props.children}</div>;
}
